<template>
	<form class="form" @submit.prevent="submit" novalidate>
		<ValidationAlert :error-list="errors.collect('server')" />
		<fieldset class="form__group">
			<div class="form__group">
				<input
                    id="name"
                    name="name"
                    class="form__control"
                    v-model="formData.name"
                    placeholder="Enter a name for your Insight..."
                    v-validate
                    required
                />
				<label for="name" class="form__label">Insight name</label>
				<div class="form__validation">{{ errors.first('name') }}</div>
			</div>
			<FormControlSector
                name="sectors"
                v-model="formData.sectors"
                v-validate="'required'"
                :multiple="true"
            />
			<div class="form__group form__group--submit">
				<button class="btn btn--primary" v-wait:disabled='"submit"'>Save &amp; Continue</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import FormControlSector from '@components/Form/Control/FormControlSector';
	import ValidationAlert from '@components/ValidationAlert';
	import InsightFormStep from './InsightFormStep';

	export default {
		name: 'InsightFormStep1',
		mixins: [InsightFormStep],
		components: {
			ValidationAlert,
			FormControlSector,
		},
		data() {
			return {
				formData: {
					name: null,
					sectors: [],
				}
			}
		},
	}
</script>
